import React, { useEffect, useState } from 'react';
import { api } from "../pages/api"; 

const SummaryWidgets = () => {
  const [widgetsData, setWidgetsData] = useState({
    totalSales: 0,
    totalOrders: 0,
    totalCustomers: 0,
    newCustomers: 0,
    todaySales: 0,
    monthlySales: 0,
  });

  const formatCurrency = (value) => {
    const num = Number(value);
    return isNaN(num) ? "0.00" : num.toFixed(2);
  };


  useEffect(() => {
    const fetchWidgetsData = async () => {
      try {
        const res = await api.get('/api/dash/widgets');
        setWidgetsData(res.data); // Set the response data into state
      } catch (err) {
        console.error('Error fetching dashboard widgets data:', err);
      }
    };

    fetchWidgetsData();
  }, []);

  return (
    <div className="row">
    {/* Widget for todays Sales */}
  <div className="col-lg-4 mb-4">
    <div className="card bg-success text-white">
      <div className="card-body">
        <h5>Today's Sales</h5>
        <p className="lead">₹{formatCurrency(widgetsData.todaySales)}</p>
      </div>
    </div>
  </div>

    {/* Widget for Monthly Sales */}
    <div className="col-lg-4 mb-4">
        <div className="card bg-secondary text-white">
          <div className="card-body">
            <h5>Monthly Sales</h5>
            <p className="lead">₹{formatCurrency(widgetsData.monthlySales)}</p>    
          </div>
        </div>
      </div>

      {/* Widget for Todays Profit */}
      <div className="col-lg-4 mb-4">
        <div className="card bg-info text-white">
          <div className="card-body">
            <h5>Todays Profit</h5>
            <p className="lead">₹{formatCurrency(widgetsData.todaysProfit)}</p>
          </div>
        </div>
      </div>

      {/* Widget for Friegt Subcidiy */}
      <div className="col-lg-4 mb-4">
        <div className="card bg-primary text-white">
          <div className="card-body">
            <h5>Frieght Sub</h5>
            <p className="lead">₹{formatCurrency(widgetsData.frieghtSub)}</p>           
          </div>
        </div>
      </div> 

        {/* Widget for avg Sales */}
        <div className="col-lg-4 mb-4">
        <div className="card bg-secondary text-white">
          <div className="card-body">
            <h5>Monthly Average Order Value</h5>
            <p className="lead">₹{formatCurrency(widgetsData.averageOrderValue)}</p>    
          </div>
        </div>
      </div>      

      {/* Widget for Today's Sales */}
      <div className="col-lg-4 mb-4">
        <div className="card bg-danger text-white">
          <div className="card-body">
            <h5>Account's Payment</h5>
            <p className="lead">₹{formatCurrency(widgetsData.accountPay)}</p>         
          </div>
        </div>
      </div>   

    </div>
  );
};

export default SummaryWidgets;
